import Vue from 'vue';
import HelpResources from '@/components/pages/StudyHomePage/helpResources/helpResources';
import TrackRespondents from '@/components/pages/StudyHomePage/activity/trackRespondents';
import TrackRecalls from '@/components/pages/StudyHomePage/activity/trackRecalls';
import NewRespondents from '@/components/pages/StudyHomePage/respondents/newRespondents';
import PastRespondents from '@/components/pages/StudyHomePage/respondents/pastRespondents';
import ManageRespondents from '@/components/pages/StudyHomePage/respondents/manageRespondents';
import AnalysisFiles from '@/components/pages/StudyHomePage/data/analysisFiles';
import NutritionReports from '@/components/pages/StudyHomePage/data/nutritionReports';
import StudyBasics from '@/components/pages/StudyHomePage/edit/studyBasics';
import StudyDetails from '@/components/pages/StudyHomePage/edit/studyDetails';
import StudyModules from '@/components/pages/StudyHomePage/edit/studyModules';
import StudyStaff from '@/components/pages/StudyHomePage/edit/studyStaff';
import StudyDelete from '@/components/pages/StudyHomePage/edit/studyDelete';
import ScheduledRespondents from '@/components/pages/StudyHomePage/activity/respondents/scheduledRespondents.vue';
import UnscheduledRespondents from '@/components/pages/StudyHomePage/activity/respondents/unscheduledRespondents';
import RecordRespondents from '@/components/pages/StudyHomePage/activity/respondents/recordRespondents';

Vue.component('help-resources', HelpResources);
Vue.component('track-respondents', TrackRespondents);
Vue.component('track-recalls', TrackRecalls);
Vue.component('new-respondents', NewRespondents);
Vue.component('past-respondents', PastRespondents);
Vue.component('manage-respondents', ManageRespondents);
Vue.component('analysis-files', AnalysisFiles);
Vue.component('nutrition-reports', NutritionReports);
Vue.component('study-basics', StudyBasics);
Vue.component('study-details', StudyDetails);
Vue.component('study-modules', StudyModules);
Vue.component('study-staff', StudyStaff);
Vue.component('study-delete', StudyDelete);
Vue.component('scheduled-respondents', ScheduledRespondents);
Vue.component('unscheduled-respondents', UnscheduledRespondents);
Vue.component('record-respondents', RecordRespondents);
